<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-text-field
      v-model="item.name"
      :rules="rules.name"
      type="text"
      label="Наименование типа файла"
    />

    <v-select
      v-model="item.fileType"
      :rules="rules.fileType"
      :items="availableTypes"
      label="Расширение файла"
    />


    <v-text-field
      v-model="item.maxFileSizeMb"
      :rules="rules.maxFileSizeMb"
      type="number"
      label="Максимальный размер файла, Мб"
    />

    <div class="d-flex justify-end">
      <v-btn v-if="isEdit" type="submit" color="primary" dark>Сохранить изменения</v-btn>
      <v-btn v-else type="submit" color="success" dark>Создать набор</v-btn>
    </div>
  </v-form>
</template>

<script>
import { mapState } from 'vuex';

const createDefaultRules = () => ({
  name: [
    v => !!v || 'Название слоя обязательно для заполнения',
  ],
  fileType: [
    v => !!v || 'Необходимо выбрать расширение файла',
  ],
  maxFileSizeMb: [
    v => v > 0 || 'Размер файла должен быть больше нуля',
  ],
});

export default {
  name: 'attachments-form',

  props: {
    item: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
  },


  data: () => ({
    rules: createDefaultRules(),
    valid: true,
  }),

  computed: {
    ...mapState('attachments', ['availableTypes']),
  },

  watch: {
    item() {
      this.$refs.form.resetValidation();
    },
  },

  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit', this.item);
        this.valid = true;
      }
    },
  },
};
</script>
